import { withCompController } from '@wix/editor-elements-integrations';
import type {
  ISlideShowContainerControllerProps,
  SlideShowContainerProps,
  ISlideShowContainerStateValues,
  ISlideShowContainerMapperProps,
} from '../SlideShowContainer.types';

export default withCompController<
  ISlideShowContainerMapperProps,
  ISlideShowContainerControllerProps,
  SlideShowContainerProps,
  ISlideShowContainerStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { updateProps } = controllerUtils;
  const { reducedMotion } = stateValues;

  return {
    ...mapperProps,
    reducedMotion,
    changeSlide: (slideIndex: number) => {
      updateProps({
        currentSlideIndex: slideIndex,
      });
    },
    play: () => {
      updateProps({
        isPlaying: true,
      });
    },
    pause: () => {
      updateProps({
        isPlaying: false,
      });
    },
    observeChildListChange: mapperProps.isMasterPage
      ? stateValues.observeChildListChangeMaster
      : stateValues.observeChildListChange,
  };
});
